export const enum IndicatorType {
    Volume = 1,
    AverageVolume = 2,
    AverageDirectionIndex = 3,
    AverageTrueRange = 4,
    RSI = 5,
    DollarVolume = 6,
    DonchianChanel = 7,
    MoneyFlowIndex = 8,
    MovingAverageEMA = 9,
    MovingAverageSMA = 10,
    MACD = 11,
    MultiPeriodHigh = 12,
    MultiPeriodLow = 13,
    PivotPoint = 14,
    RateOfChange = 15,
    RelativeVolume = 16,
    DistanceFromEMA = 17,
    Stochastics = 18,
    TIStrength = 19,
    VWAP = 20,
    BBands = 21,
    BBWidth = 22,
    Drawdown = 23,
    KeltnerChannel = 24,
    TIPatternRec = 25,
    WilliamR = 26,
    AVWAP = 27,
    EMACloud = 28,
    HighChartPivotPoints = 211,
    HighChartIKH = 212,
    HighChartAD = 213,
    HighChartMFI = 214,
    HighChartVolume = 215,    
    HighChartCCI = 216,
    HighChartStochastic = 217,
    IndicatorManager = 999
}
